// currently some sanity types have the _type field aliased to type, so check both
export const getType = (menuData: { _type: string } | { type: string; _type?: null }) => {
  return menuData._type ?? (menuData as any).type;
};
